//import {galleryData} from "../store/GalleryData"
import request from '../utils/request.js';
import { IGalleryStatus, IListResult, IResult } from '../global';
export interface IOneMediaItem {
  id: number;
  type: string;
  source: string;
  desc: string;
  status: IGalleryStatus;
  gallery_id: number;
  view: number;
  uv?: number;
  thumb: string;
  second_url?: string;
  begin_at?: string;
  end_at?: string;
  play_back_url?: string;
  cut_play_url?: string;
}

export interface IMediaListResult {
  total: number;
  data: {
    items: IOneMediaItem[];
  };
}

export type IDownloadListOne = {
  id: number;
  url: string;
};
const gallery = {
  // 这个接口移动到小程序上了，不过这里还是先保留，方便后续查阅
  // 添加到下载列表
  // downloadAdd: async function(
  //   list: IDownloadListOne[]
  // ): Promise<{ id: number; token: string }> {
  //   const result = await request({
  //     method: 'post',
  //     url: `/api/v2/downlist/add`,
  //     type: 'jsonv2',
  //     data: JSON.stringify({
  //       gallery_id: window.gallery.id, // 跟后端确认是用父相册的
  //       type: 'image',
  //       targets: list
  //     }),
  //     headers: {
  //       Authorization: request.token
  //     }
  //   });
  //   const { code, message, data = {} } = result;
  //   const { id } = data;
  //   if (code === 200) {
  //     return {
  //       id,
  //       token: request.token
  //     };
  //   }
  //   throw new Error(message);
  // },
  one: (id: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/gallery/' + id
      })
        .then((res = {}) => {
          if (res && res.pagedata) {
            if (typeof res.pagedata !== 'object') {
              try {
                res.pagedata = JSON.parse(res.pagedata);
              } catch (e) {
                res.pagedata = {};
              }
            }
          }
          if (res && res.watermarks) {
            if (typeof res.watermarks !== 'object') {
              try {
                res.watermarks = JSON.parse(res.watermarks);
              } catch (e) {
                res.watermarks = [];
              }
            }
          }
          res.tags =
            res.tags instanceof Array ? res.tags : (res.tags || '').split(',');
          return res;
        })
        .then(resolve)
        .catch(reject);
    });
  },
  children: (id: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/gallery/children/' + id
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  eventShow: (data: any) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/stat/show',
        data: data
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },
  // 批量获取相册信息，以及其统计统计
  batch: (ids: string[]) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/gallery/batch',
        data: {
          ids: ids.join(',')
        }
      })
        .then(res => {
          let old_gallery = ids.filter(
            (id: string | number, index: number) =>
              Number(id) < 1000000 && index < 50
          );
          if (old_gallery && old_gallery.length) {
            try {
              let promises = old_gallery.map((id: string | number) => {
                return gallery.one(Number(id));
              });

              Promise.all(promises).then((oldres: any[]) => {
                if (oldres && oldres.length) {
                  oldres = oldres.map((it: any) => {
                    return {
                      ...it,
                      view_detail: {
                        gallery_id: it.id,
                        uv: 0,
                        view: Number(it.imageviews) || Number(it.view)
                      },
                      image_total: Number(it.imagecount),
                      img_total: Number(it.imagecount)
                    };
                  });

                  if (res && res.data && res.data instanceof Array) {
                    res.data = res.data.concat(oldres);
                  }
                }
                console.log(res);
                resolve(res);
              });
            } catch (e) {
              resolve(res);
            }
          } else {
            resolve(res);
          }
        })
        .catch(reject);
    });
  },
  person: (galleryid: string, page: number = 1) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/face3/person',
        data: {
          galleryid,
          page,
        }
        // headers: {
        //   Authorization: request.token
        // }
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    });
  },

  //新接口
  linkLatest: (link: string) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallery_visit/link/${link}/latest`
      })
        .then(res => {
          resolve(res);
        })
        .catch(reject);
    }),
  // 单个直播视频数据
  getLiveDetail: (livevideoid: string) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: '/api/v2/live/source/getone?id=' + livevideoid
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  // 媒体数据
  mediaList: (galleryid: string) =>
    new Promise<IMediaListResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerymedium/list?gallery_id=${galleryid}`
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  checkWatermark: (galleryid: number) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallery/watermark/ispass/${galleryid}`,
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  doWatermark: (data: any) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallery/watermark/visit/check`,
        method: 'POST',
        type: 'jsonv2',
        data: JSON.stringify(data),
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  checkPermission: (linkid: string) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerypgdata/permisson/ispass/${linkid}`,
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  doPermission: (data: any) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerypgdata/permisson/visit/check`,
        method: 'POST',
        type: 'jsonv2',
        data: JSON.stringify(data),
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  sendValidate: (phone: string, country: string = '86') =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/common/sms/send`,
        method: 'POST',
        type: 'jsonv2',
        data: JSON.stringify({
          mobile: (country ? country : '') + phone,
          country
        }),
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  validateCodeV2: (phone: string, country: string = '86', code: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/policy/sms/validation`,
        method: 'POST',
        type: 'jsonv2',
        data: JSON.stringify({
          phone: (country ? country : '') + phone,
          code
        }),
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    });
  },
  validatePhoneV2: (linkid: string, whitelist: number, action: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/policy/records/${linkid}/validation?forcewhitelist=${whitelist}`,
        method: 'POST',
        type: 'jsonv2',
        data: JSON.stringify({
          action
        }),
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    });
  },
  validatePostPaperV2: (
    linkid: string,
    parentLinkId: string,
    action: string,
    rawData: any
  ) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/policy/records/${linkid}/paper`,
        method: 'POST',
        type: 'jsonv2',
        data: JSON.stringify({
          action,
          parent: parentLinkId,
          json_data: rawData
        }),
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    });
  },
  validatePassV2: (linkid: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/permissibility?link=${linkid}`,
        method: 'GET',
        type: 'jsonv2',
        credentials: 'include',
        headers: {
          Authorization: request.token
        }
      })
        .then(res => resolve(res))
        .catch(reject);
    });
  },
  // 根据父相册link 获取子相册列表
  //link: gallery 唯一 hashid DB字段 link
  childlist: (link: string) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallery/link/${link}/childlist`,
        method: 'get',
        type: 'jsonv2'
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  getParentPgData: (linkid: string) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerypagedata/${linkid}/parentpgdetail`,
        method: 'get',
        type: 'jsonv2'
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  imagesHot: (galleryid: string, page: number) =>
    new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/images/hot/${galleryid}?page=${page}`,
        method: 'get',
        type: 'jsonv2'
      })
        .then(res => resolve(res))
        .catch(reject);
    }),
  getVideoQrcodeTicket: (videoid: number, linkid: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/common/util/video/qrcodeTicket?videoid=${videoid}&linkid=${linkid}`
      })
        .then(resolve)
        .catch(reject);
    });
  },
  getNoticeStatus: (videoid: number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/live/remind/${videoid}`,
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  getCustomForm: (linkid: string) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/gallerypagedata/customform/${linkid}`
      })
        .then(resolve)
        .catch(reject);
    });
  },
  getPayGood: (gallery_id: string | number, goods_id: string | number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/pay/good/${gallery_id}/${goods_id}/info`
      })
        .then(resolve)
        .catch(reject);
    });
  },
  makePrePay: (
    gallery_id: string | number,
    link_id: string,
    goods_id: string | number
  ) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/pay/pre`,
        method: 'POST',
        type: 'jsonv2',
        credentials: 'include',
        data: JSON.stringify({
          gallery_id,
          goods_id,
          link_id
        }),
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  makePayUseCharge: (
    gallery_id: string | number,
    charge_id: string | number
  ) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/pay/charge`,
        method: 'POST',
        type: 'jsonv2',
        credentials: 'include',
        data: JSON.stringify({
          gallery_id,
          charge_id
        }),
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  checkPayResult: (gallery_id: string | number, goods_id: string | number) => {
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/pay/check`,
        method: 'POST',
        type: 'jsonv2',
        credentials: 'include',
        data: JSON.stringify({
          gallery_id,
          goods_id
        }),
        headers: {
          Authorization: request.token
        }
      })
        .then(resolve)
        .catch(reject);
    });
  },
  getPosterDiyTemplate: (ids: string)=>{
    return new Promise<IResult>((resolve, reject) => {
      request({
        url: `/api/v2/poster/list/${window.gallery.id}?ids=${ids}`,
        method: 'GET',
        type: 'jsonv2',
      })
        .then(resolve)
        .catch(reject);
    });
  }
};

export default gallery;
